<template>
  <div>
    <b-dropdown
      class="m-2 d-none d-md-inline"
      id="dropdown-form"
      size="sm"
      dropleft
      text="Filtros"
      variant="primary"
      ref="dropdown"
    >
      <template v-slot:button-content>
        <i class="fas fa-filter" /> Filtros
      </template>
      <b-dropdown-header>
        <h5>&nbsp;</h5>
      </b-dropdown-header>
      <b-dropdown-form style="min-width:400px;">
        <slot></slot>
        <hr />

        <div class="col text-center">
          <button type="button" class="btn btn-sm btn-primary" @click="$emit('filter')">
            <i class="fas fa-search" /> Filtrar
          </button>
        </div>
      </b-dropdown-form>
    </b-dropdown>

    <b-modal ref="modal" title="Filtros" header-class="border-bottom-0">
      <slot></slot>
      <div slot="modal-footer">
        <button type="button" class="btn btn-sm btn-primary" @click="onFilterFromModal">
          <i class="fas fa-search" /> Filtrar
        </button>
      </div>
    </b-modal>

    <button
      type="button"
      class="btn d-inline d-md-none btn-sm btn-primary ml-2"
      @click="$refs.modal.show()"
    >
      <i class="fas fa-filter" /> Filtros
    </button>
  </div>
</template>

<script>
export default {
  methods : {
    onFilterFromModal() {
      this.$emit('filter')
      this.$refs.modal.hide()
    }
  }
};
</script>

<style>
</style>